// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xx-1";
export var printerIcon = "_xx-0";